/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const ACCPBOSS_ADD = 'ACCPBOSS_ADD';
export const ACCPBOSS_BEGIN = 'ACCPBOSS_BEGIN';
export const ACCPBOSS_FAILURE = 'ACCPBOSS_FAILURE';
export const ACCPBOSS_CLEAR = 'ACCPBOSS_CLEAR';

export const ACCPBOSS_FILTER_BEGIN = 'ACCPBOSS_FILTER_BEGIN';
export const ACCPBOSS_FILTER_SUCCESS = 'ACCPBOSS_FILTER_SUCCESS';
export const ACCPBOSS_FILTER_FAILURE = 'ACCPBOSS_FILTER_FAILURE';
export const ACCPBOSS_FILTER_CLEAR = 'ACCPBOSS_FILTER_CLEAR';

export const ACCPBOSSAVAILABLE_ADD = 'ACCPBOSSAVAILABLE_ADD';
export const ACCPBOSSAVAILABLE_BEGIN = 'ACCPBOSSAVAILABLE_BEGIN';
export const ACCPBOSSAVAILABLE_FAILURE = 'ACCPBOSSAVAILABLE_FAILURE';
export const ACCPBOSSAVAILABLE_CLEAR = 'ACCPBOSSAVAILABLE_CLEAR';
export function fetchACCPBoss(params = {}) {
	return async dispatch => {
        dispatch(accpBossBegin());
        await ApiService.getEmployeeBoss(params)
			.then(
            result => {
                let normalized = normalizeById(result.Data, 'employeeId');
                    dispatch(accpBossAdd(normalized));
					return normalized;
				},
				error => {
                    dispatch(accpBossError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchACCPBossFilter(params = {}) {
    return async dispatch => {
        await ApiService.getEmployeeBossFilter(params)
            .then(
                result => {
                    dispatch(accpBossFilterAdd(result));
                },
                error => {
                    dispatch(accpBossFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchACCPBossAvailable(params = {}) {
    return async dispatch => {
        dispatch(accpBossAvailableBegin());
        await ApiService.getEmployeeBossAvailable(params)
            .then(
            result => {
                dispatch(accpBossAvailableAdd(result));
                },
                error => {
                    dispatch(accpBossAvailableError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

//ACCPBoss
export const accpBossBegin = () => ({
    type: ACCPBOSS_BEGIN,
});

export const accpBossAdd = data => ({
    type: ACCPBOSS_ADD,
	payload: { data }
})

export const accpBossError = () => ({
    type: ACCPBOSS_FAILURE,
})

export const accpBossClear = () =>({
    type: ACCPBOSS_CLEAR,
})

//ACCPBoss Filters
export const accpBossFilterBegin = () => ({
    type: ACCPBOSS_FILTER_BEGIN,
});
export const accpBossFilterAdd = filterData => ({
    type: ACCPBOSS_FILTER_SUCCESS,
    payload: { filterData }
})
export const accpBossFilterError = filterError => ({
    type: ACCPBOSS_FILTER_FAILURE,
    payload: { filterError }
})

export const accpBossFilterClear = () => ({
    type: ACCPBOSS_FILTER_CLEAR,
})

//ACCPBossAvailable
export const accpBossAvailableBegin = () => ({
    type: ACCPBOSSAVAILABLE_BEGIN,
});

export const accpBossAvailableAdd = data => ({
    type: ACCPBOSSAVAILABLE_ADD,
    payload: { data }
})

export const accpBossAvailableError = () => ({
    type: ACCPBOSSAVAILABLE_FAILURE,
})

export const accpBossAvailableClear = () => ({
    type: ACCPBOSSAVAILABLE_CLEAR,
})
